
const fields = [
  {
    type: 'bsx-input',
    inputType: 'text',
    label: '課程地點',
    model: 'name',
    placeholder: '課程地點',
    required: true,
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-input',
    inputType: 'text',
    label: '課程地址',
    model: 'address',
    placeholder: '課程地址',
    required: true,
    validator: function () {
      this.validation();
    },
  },
];

export default fields;
